var ensureObject = { exports: {} };
export {
  ensureObject as __module
};
//# sourceMappingURL=ensureObject.js.map
